var _title, _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgTutorialExcercisesIcon = function SvgTutorialExcercisesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Menu/ Goal")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Menu/-Goal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(14.000000, 13.500000) rotate(-45.000000) translate(-14.000000, -13.500000) translate(3.000000, 5.000000)",
    stroke: "#B2B2B2",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 7,
    y: 7,
    width: 8,
    height: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1,6.5 L11,6.5 C12.1045695,6.5 13,7.3954305 13,8.5 C13,9.6045695 12.1045695,10.5 11,10.5 L-1,10.5 C-2.1045695,10.5 -3,9.6045695 -3,8.5 C-3,7.3954305 -2.1045695,6.5 -1,6.5 Z",
    id: "Rectangle",
    transform: "translate(5.000000, 8.500000) rotate(-270.000000) translate(-5.000000, -8.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.5,7 L5.5,7 C6.32842712,7 7,7.67157288 7,8.5 C7,9.32842712 6.32842712,10 5.5,10 L-2.5,10 C-3.32842712,10 -4,9.32842712 -4,8.5 C-4,7.67157288 -3.32842712,7 -2.5,7 Z",
    id: "Rectangle",
    transform: "translate(1.500000, 8.500000) rotate(-270.000000) translate(-1.500000, -8.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,6.5 L23,6.5 C24.1045695,6.5 25,7.3954305 25,8.5 C25,9.6045695 24.1045695,10.5 23,10.5 L11,10.5 C9.8954305,10.5 9,9.6045695 9,8.5 C9,7.3954305 9.8954305,6.5 11,6.5 Z",
    id: "Rectangle",
    transform: "translate(17.000000, 8.500000) rotate(-270.000000) translate(-17.000000, -8.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5,7 L24.5,7 C25.3284271,7 26,7.67157288 26,8.5 C26,9.32842712 25.3284271,10 24.5,10 L16.5,10 C15.6715729,10 15,9.32842712 15,8.5 C15,7.67157288 15.6715729,7 16.5,7 Z",
    id: "Rectangle",
    transform: "translate(20.500000, 8.500000) rotate(-270.000000) translate(-20.500000, -8.500000) "
  })))));
};

export default __webpack_public_path__ + "static/media/tutorial-excercises-icon.f7885e20.svg";
export { SvgTutorialExcercisesIcon as ReactComponent };